var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer",class:{ [`footer-${_vm.type}`]: _vm.type },attrs:{"data-background-color":_vm.backgroundColor}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v(" © "+_vm._s(_vm.year)+", Restaurante Torreondo, Usansolo. ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }